import { useCallback, useState } from 'react';

type UseSeriaPlusInteractionPauseResult = {
  handleProgressBarMouseEnter: () => void;
  handleProgressBarMouseLeave: () => void;
  handleTooltipClose: () => void;
  handleTooltipOpen: () => void;
  isInteractionPaused: boolean;
};

export function useSeriaPlusInteractionPause(): UseSeriaPlusInteractionPauseResult {
  const [isProgressBarHovered, setIsProgressBarHovered] = useState(false);
  const [openTooltipCount, setOpenTooltipCount] = useState(0);

  const handleProgressBarMouseEnter = useCallback((): void => {
    setIsProgressBarHovered(true);
  }, []);

  const handleProgressBarMouseLeave = useCallback((): void => {
    setIsProgressBarHovered(false);
  }, []);

  const handleTooltipOpen = useCallback((): void => {
    setOpenTooltipCount(currentCount => currentCount + 1);
  }, []);

  const handleTooltipClose = useCallback((): void => {
    setOpenTooltipCount(currentCount => Math.max(0, currentCount - 1));
  }, []);

  return {
    handleProgressBarMouseEnter,
    handleProgressBarMouseLeave,
    handleTooltipClose,
    handleTooltipOpen,
    isInteractionPaused: isProgressBarHovered || openTooltipCount > 0,
  };
}
